<template>
<div id="dashboard" class="container">
    <h3>Dashboard</h3>
    <div class="table-responsive">
     <table class="table ">
         <thead>
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th> View Message</th>
            </tr>
         </thead>
        <tbody>
            <tr v-for="contacts in contact" v-bind:key="contacts.id">
            <td>{{contacts.name}}</td>
            <td>{{contacts.email}}</td>
            <td>{{contacts.message}}</td>
            </tr>
        </tbody>
    </table>
    </div>
    <div class="container">
        
           
                <button type="submit" v-on:click="logout" class="btn btn-danger">Logout</button>
            
        
    </div>
</div>
</template>
<script>
import firebase from 'firebase'
import db from './firebaseInit'
export default {
  name: 'dashboard',
   data (){
        return {
            contact: [],
            isLoggedIn: false,
            currentUser: false
        }
    },
    methods: {
        logout: function(){
            firebase
            .auth().signOut()
            .then(()=>{
                this.$router.push('/view-message');
            });
        }
    },
    created () {
        db.collection('contact').get().then(querySnapshot =>{
            querySnapshot.forEach(doc => {
                const data = {
                    'id' : doc.data().id,
                    'mid' : doc.data().mid,
                    'name': doc.data().name,
                    'email': doc.data().email,
                    'message' : doc.data().message
                }
                this.contact.push(data)
            })
        })
    }
}
</script>

<style scoped>
td{
    font-family: cursive;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard.vue